import { UUID } from "crypto";

export const groupKeys = {
  all: ["groups"] as const,
  lists: () => [...groupKeys.all, "list"] as const,
  myGroups: () => [...groupKeys.all, "my-groups"] as const,
  companyGroups: () => [...groupKeys.all, "company"] as const,
  options: () => [...groupKeys.all, "options"] as const,
  details: () => [...groupKeys.all, "detail"] as const,
  detail: (id: UUID) => [...groupKeys.details(), id] as const,
} as const;
